import { Theme } from '@mui/material';
import { Colors } from '../../../utils/theme';

export const headerNavStyles = (theme: Theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		marginLeft: 'auto',
	},
	list: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		columnGap: { xs: '20px', lg: '30px' },
		textTransform: 'uppercase',
	},
	links: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: '1rem',
		fontWeight: '600',
		fontSize: '14px',
		fontFamily: 'Integral CF',

		'& > *': {
			cursor: 'pointer',
			color: 'inherit',
			textDecoration: 'none',
		},
	},
	link: {
		'&:hover': {
			textDecoration: 'underline',
			textDecorationColor: Colors['FF6000'],
			textDecorationThickness: '2px',
			textUnderlineOffset: '4px',
		},
	},
	textNowrap: {
		whiteSpace: 'nowrap',
	},
	textNoDecoration: {
		textDecoration: 'none'
	},
	hideOnMobile: {
		display: { xs: 'none', md: 'flex' },
	},
});
